import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Spoiler } from '@mantine/core';
import { fixHtmlHrefUrls } from '../../helpers/format';

const AppTextEditorContent = ({ content, previewHeight }) => {
  const [contentState, setContentState] = useState(null);

  useEffect(() => {
    if (content) {
      const sanitizedHtml = DOMPurify.sanitize(content);
      setContentState(fixHtmlHrefUrls(sanitizedHtml));
    }
    else {
      setContentState(null);
    }
  }, [content]);

  return contentState ? (
    previewHeight ? (
      <Spoiler
        hideLabel="Show less"
        maxHeight={previewHeight}
        showLabel="Show more"
        styles={{ control: { width: '100%' } }}
      >
        <div dangerouslySetInnerHTML={{ __html: contentState }} />
      </Spoiler>
    ) : (
      <div dangerouslySetInnerHTML={{ __html: contentState }} />
    )
  ) : null;
};

AppTextEditorContent.propTypes = {
  content: PropTypes.string,
  previewHeight: PropTypes.number
};

export default AppTextEditorContent;
